export interface FeedUser {
  id: string;
  firstName: string;
  lastName: string;
  network?: Network;
  facebookId?: string;
  relationship: Relationship;
  friendOf?: FeedUser;
}

export interface FeedSite {
  id: string;
  name: string;
  key: string;
}

export enum Relationship {
  Friend = 'FRIEND',
  FriendOfFriend = 'FRIEND_OF_FRIEND',
  Neighbour = 'NEIGHBOUR'
}

export interface Activity {
  id: string;
  name?: string;
  postcode: number;
  suburb: string;
  categoryId: number;
  recommendationId: number;
  date: string;
  type: ActivityType;
  siteId: number;
  user: FeedUser;
  site?: FeedSite;
  category?: { key: string; id: string; name: string };
  recommendation?: { id: string; comment: string };
}

export enum ActivityType {
  JOINED_HIPAGES = 1,
  POSTED_JOB = 2,
  RECOMMENDED_TRADIE = 3,
  HIRED_TRADIE = 4
}

export enum Scope {
  FRIENDS = 'friends',
  NEIGHBOURS = 'neighbours',
  FRIENDS_OF_FRIENDS = 'friendsOfFriends'
}

export enum Network {
  FACEBOOK = 1,
  CONTACTS = 4
}

export enum FeedSort {
  email = 'email'
}

export interface FeedOptions {
  postcode: number;
  userId: number;
  filter: ActivityType[];
  scope: Scope[];
  limit: number;
  offset: number;
  days: number;
  sort?: FeedSort;
}
